import { useDispatch } from 'react-redux';

import { useApiQuery } from 'theSource/utils';
import { ContentSettingsResponseDto } from './types';
import {
  CONTENT_SETTINGS_ENDPOINT,
  GET_CONTENT_SETTINGS_QUERY_KEY,
} from './utils';
import { setAuthenticated } from 'theSource/features';
import { INVALID_SUBSCRIBER_ERROR_CODE } from 'queries';

export interface UseContentSettingsQueryProps {
  enabled: boolean;
}

export const useContentSettingsQuery = ({
  enabled,
}: UseContentSettingsQueryProps) => {
  const dispatch = useDispatch();

  const {
    data: contentSettings,
    isLoading: isLoadingContentSettings,
    isFetching: isFetchingContentSettings,
  } = useApiQuery<ContentSettingsResponseDto, unknown>({
    queryKey: GET_CONTENT_SETTINGS_QUERY_KEY,
    endpoint: CONTENT_SETTINGS_ENDPOINT,
    showErrorSnackbar: false,
    enabled,
    onError(err) {
      if (err.response?.data?.error_code === INVALID_SUBSCRIBER_ERROR_CODE) {
        dispatch(setAuthenticated(false));
      }
    },
  });

  return {
    contentSettings,
    isLoadingContentSettings,
    isFetchingContentSettings,
  };
};
